
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EnhancedOffer } from '@/lib/api/offers/types';

interface UserActivityCardProps {
  userOffers: EnhancedOffer[];
}

export const UserActivityCard = ({ userOffers }: UserActivityCardProps) => {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {userOffers && userOffers.length > 0 ? (
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Recent Offers</h3>
            <div className="grid grid-cols-1 gap-4">
              {userOffers.slice(0, 3).map((offer) => (
                <div key={offer.id} className="border rounded-lg p-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-medium">{offer.title}</h4>
                      <div className="flex items-center mt-1">
                        <Badge variant="outline" className="mr-2">
                          {offer.link_type}
                        </Badge>
                        <span className="text-sm text-muted-foreground">
                          DR {offer.dr} | DA {offer.da}
                        </span>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-bold">${offer.price_cents / 100}</div>
                      <div className="text-xs text-muted-foreground">
                        {offer.turnaround_days} day turnaround
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 flex justify-end">
                    <Button variant="ghost" size="sm" asChild>
                      <Link to={`/offers/${offer.id}`}>
                        <ExternalLink className="h-4 w-4 mr-1" /> View Offer
                      </Link>
                    </Button>
                  </div>
                </div>
              ))}
            </div>
            {userOffers.length > 3 && (
              <div className="flex justify-end mt-2">
                <Button variant="outline" size="sm" asChild>
                  <Link to={`?tab=offers`}>
                    View All Offers
                  </Link>
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-10 text-muted-foreground">
            No recent activity to display
          </div>
        )}
      </CardContent>
    </Card>
  );
};
